<template>

  <el-main
    class="main_content"
    style="padding: 0"
  >
    <div class="cont_navs_header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>
          <a>商城管理</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item><a @click="jumpTo('/ac20OrderList')">202012月活动订单管理</a></el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="contain_div">

      <div class="contain_header clr">
        <el-form
          :inline="true"
          class="m-search"
          size='small'
          :model="filters"
        >

          <el-form-item label="代理类型">
            <el-select
              v-model="filters.roleType"
              placeholder="请选择"
              clearable
            >
              <el-option
                label="康减系列VIP会员"
                value="-0.5"
              ></el-option>
              <el-option
                label="康减系列荣誉会员"
                value="-0.4"
              ></el-option>
              <el-option
                label="康减系列高级会员"
                value="-0.3"
              ></el-option>

              <el-option
                label="VIP门店"
                value="0"
              ></el-option>
              <el-option
                label="联盟店"
                value="1"
              ></el-option>
              <el-option
                label="优秀联盟店"
                value="1.05"
              ></el-option>

              <el-option
                label="康减系列市代"
                value="1.1"
              ></el-option>
              <el-option
                label="市代"
                value="2"
              ></el-option>
              <el-option
                label="康减系列省代"
                value="2.1"
              ></el-option>
              <el-option
                label="省代"
                value="3"
              ></el-option>

            </el-select>
          </el-form-item>

          <el-form-item label="数量开始:">
            <el-input
              style="width: 150px;"
              type="number"
              v-model="filters.buyBeginNum"
              placeholder="请输入开始数量"
            >
            </el-input>

          </el-form-item>

          <el-form-item label="数量结束:">
            <el-input
              style="width: 150px;"
              type="number"
              v-model="filters.buyEndNum"
              placeholder="请输入结束数量"
            >
            </el-input>

          </el-form-item>

          <el-form-item>
            <el-button
              type="primary"
              @click="handleSearch"
            >搜索</el-button>
            <el-button
              @click="excelOut"
              type="primary"
              size="small"
            >导出</el-button>
          </el-form-item>
        </el-form>
      </div>

      <div class="contain_body">
        <div class="contain_body_head">
        </div>
        <el-table
          :data="tableData"
          :height="tableHeight"
          v-loading='tableDataLoading'
          style="width: 100%"
          :header-cell-class-name='objectSpanMethod'
        >

          <el-table-column
            prop="username"
            label="代理姓名"
          >
          </el-table-column>

          <el-table-column
            prop="role_type"
            :formatter="formatterRoleType"
            label="代理等级"
          >
          </el-table-column>

          <el-table-column label="代理头像">
            <template slot-scope="scope">
              <img
                :src="scope.row.user_head"
                style="width:50px;"
              >
            </template>
          </el-table-column>

          <el-table-column
            prop="order_code"
            label="订单号"
          >
          </el-table-column>

          <el-table-column
            prop="up_name"
            label="上级姓名"
          >
          </el-table-column>

          <el-table-column
            prop="up_tel"
            label="上级手机号"
          >
          </el-table-column>

          <el-table-column
            prop="up_role"
            :formatter="formatterRoleType1"
            label="上级代理等级"
          >
          </el-table-column>

          <el-table-column
            prop="total_money"
            label="总金额"
          >
          </el-table-column>

          <el-table-column
            prop="total_num"
            label="总数量"
          >
          </el-table-column>

          <el-table-column
            prop="create_time"
            label="下单时间"
          >
          </el-table-column>
          <el-table-column
            prop="order_type"
            :formatter="formatterOrderType"
            label="订单类型"
          >
          </el-table-column>

          <el-table-column
            prop="status"
            label="订单详情"
          >
            <template slot-scope="scope">
              <!-- <el-button
                type="primary"
                size="small"
                @click="showOrderDetail(scope.row)"
              >查看</el-button> -->
              <router-link
                target="_blank"
                :to="{path:'/orderDetail',query:{orderId:scope.row.id}}"
              >查看</router-link>
            </template>
          </el-table-column>



        </el-table>
        <div class="pageDiv block">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="page_num"
            :page-count='total_page'
            :page-size="page_size"
            layout="total, prev, pager, next"
            :total="total_num"
          >
          </el-pagination>
        </div>
      </div>

    </div>


  </el-main>
</template>


<script>
import { bus } from "../../bus.js";
import API from "../../api/api_user";
import { dateFunc } from "../../dateFunc";
var _ = require("lodash");
export default {
  name: "orderList",
  created() {},
  data() {
    return {
      subListVisible: false,
      dialogBatchInVisible: false,
      batchInPostLoading: false,
      tableDataLoading: false,
      searchUserId: null,
      tableData1: [],
      form: {
        excelFile: null,
      },
      file: null,
      filters: {
        roleType: null,
        buyBeginNum:null,
        buyEndNum:null
      },
      page_num: 1,
      subList: [],
      buList: [],
      pickerOptions1: 1,
      value2: "",
      tableData: [],
      total_num: 0,
      subListLoading: false,
      total_page: 0,
      page_size: 10,
      tableHeight: null,
    };
  },
  mounted() {
    this.tableHeight = document.documentElement.clientHeight - 330;
    this.page_num = 1;
    this.handleSearch();
  },
  methods: {
    showOrderDetail(row) {
      let that = this;
      that.subListVisible = true;
      that.subListLoading = true;
      let para = {
        token: localStorage.getItem("api_token"),
        id: row.id,
      };
      API.good_order_detail(para)
        .then(
          function (result) {
            that.subListLoading = false;
            if (result && parseInt(result.key) === 1000) {
              that.subList = result.result.map.sub;
              if (result.result.map.orders != null) {
                that.buList = result.result.map.orders;
              } else {
                that.buList = [];
              }
            }
          },
          function (err) {
            that.subListLoading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000,
            });
          }
        )
        .catch(function (error) {
          that.subListLoading = false;
          console.log(error);
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000,
          });
        });
    },
    getFile(event) {
      this.file = event.target.files[0];
      console.log(this.file);
    },



    excelOut() {
      var that = this;
      var url =
        "/manager/user/pc/check_send_thing_excel?token=" +
        localStorage.getItem("api_token");

      if (that.filters.buyBeginNum) {
        url = url + "&buyBeginNum=" + that.filters.buyBeginNum;
      }
      if (that.filters.buyEndNum) {
        url = url + "&buyEndNum=" + that.filters.buyEndNum;
      }
      url = url + "&havePro=" + 1;
      if (that.filters.roleType) {
        url = url + "&roleType=" + that.filters.roleType;
      }
      top.location.href = url;
    },

    formatterRoleType1(row, column) {
      var word = "";
      if (row.up_role == -1) {
        word = "无";
      } else if (row.up_role == -0.5) {
        word = "康减系列vip会员";
      } else if (row.up_role == -0.4) {
        word = "康减系列高级会员";
      } else if (row.up_role == -0.3) {
        word = "康减系列荣誉会员";
      } else if (row.up_role == 0) {
        word = "VIP门店";
      } else if (row.up_role == 1) {
        word = "联盟店";
      } else if (row.up_role == 2) {
        word = "市代";
      } else if (row.up_role == 3) {
        word = "省代";
      } else if (row.up_role == 4) {
        word = "CEO";
      } else if (row.up_role == 1.1) {
        word = "康减系列市代";
      } else if (row.up_role == 2.1) {
        word = "康减系列省代";
      } else if (row.up_role == 3.1) {
        word = "康减系列CEO";
      } else if (row.up_role == 1.05) {
        return "优秀联盟店";
      } else if (row.up_role == 5) {
        return "总经销商";
      } else if (row.up_role == 2.2) {
        return "合伙人";
      } else if (row.up_role == 4.2) {
        return "董事";
      } else if (row.up_role == 5.1) {
        return "区域总监";
      } else if (row.up_role == 5.2) {
        return "城市加盟商";
      } else if (row.up_type == 4.8) {
        return "经销商";
      }
      if (row.special_status == 2) {
        word = word + "-" + "特殊";
      }
      return word;
    },

    formatterRoleType(row, column) {
      var word = "";
      if (row.role_type == -1) {
        word = "无";
      } else if (row.role_type == -0.5) {
        word = "康减系列vip会员";
      } else if (row.role_type == -0.4) {
        word = "康减系列高级会员";
      } else if (row.role_type == -0.3) {
        word = "康减系列荣誉会员";
      } else if (row.role_type == 0) {
        word = "VIP门店";
      } else if (row.role_type == 1) {
        word = "联盟店";
      } else if (row.role_type == 2) {
        word = "市代";
      } else if (row.role_type == 3) {
        word = "省代";
      } else if (row.role_type == 4) {
        word = "CEO";
      } else if (row.role_type == 1.1) {
        word = "康减系列市代";
      } else if (row.role_type == 2.1) {
        word = "康减系列省代";
      } else if (row.role_type == 3.1) {
        word = "康减系列CEO";
      } else if (row.role_type == 1.05) {
        return "优秀联盟店";
      } else if (row.role_type == 5) {
        return "总经销商";
      } else if (row.role_type == 2.2) {
        return "合伙人";
      } else if (row.role_type == 4.2) {
        return "董事";
      } else if (row.role_type == 5.1) {
        return "区域总监";
      } else if (row.role_type == 5.2) {
        return "城市加盟商";
      } else if (row.role_type == 4.8) {
        return "经销商";
      }
      if (row.special_status == 2) {
        word = word + "-" + "特殊";
      }
      return word;
    },


    formatterOrderType(row, column) {
      if (row.order_type == 1) {
        return "发货订单";
      } else if (row.order_type == 2) {
        return "购进订单";
      } else if (row.order_type == 3) {
        return "待补货订单";
      } else if (row.order_type == 4) {
        return "已补货订单";
      }
    },

    upHouse(row) {
      this.$router.push({ path: "/up_article", query: { id: row.id } });
    },


    handleSearch() {
      this.page_size = 10;
      this.page_num = 1;
      this.search();
    },
    search() {
      let that = this;

      let params = {
        page_num: that.page_num,
        havePro:1,
        page_size: that.page_size,
        token: localStorage.getItem("api_token"),
      };
      if (that.filters.roleType) {
        params.roleType = that.filters.roleType;
      }
      if (that.filters.buyBeginNum) {
        params.buyBeginNum = that.filters.buyBeginNum;
      }
      if (that.filters.buyEndNum) {
        params.buyEndNum = that.filters.buyEndNum;
      }
      that.tableDataLoading = true;
      API.check_send_thing_list(params)
        .then(
          function (result) {
            that.tableDataLoading = false;
            if (result.key == 1000) {
              that.total_num = result.result.count;
              that.total_page = result.result.allPageNumber;
              if (result.result.list && result.result.list.length > 0) {
                for (var i = 0; i < result.result.list.length; i++) {
                  result.result.list[i].create_time = dateFunc.formatDate(
                    new Date(parseInt(result.result.list[i].create_time)),
                    "yyyy-MM-dd hh:mm:ss"
                  );
                }
              }
              that.tableData = result.result.list;
            }
          },
          function (err) {
            that.tableDataLoading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000,
            });
          }
        )
        .catch(function (error) {
          that.tableDataLoading = false;
          console.log(error);
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000,
          });
        });
    },
    jumpTo(url) {
      this.$router.push(url); //用go刷新
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    objectSpanMethod({ row, rowIndex }) {
      return "table_head";
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.search();
    },
  },
};
</script>

<style>
.table_head {
  background-color: #f8f8f8 !important;
  border-right: 1px solid #eee;
  border-bottom: 1px solid #eee;
  border-top: 1px solid #eee;
}

.main_content {
  position: absolute;
  left: 210px;
  top: 105px;
  right: 0;
  bottom: 0;
  background-color: #f2f2f2;
  padding: 0;
}

.cont_navs {
  background-color: #fff;
  width: 100%;
  height: 55px;
  box-sizing: border-box;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  text-align: center;
  margin-bottom: 20px;
}
.cont_navs li {
  display: inline-block;
  line-height: 21px;
  padding: 17px 0;
  margin: 0 20px;
  height: 55px;
  color: #bbb;
  font-size: 15px;
  text-align: center;
  cursor: pointer;
}
.cont_navs li:hover {
  color: #409eff;
}

.ac_li {
  color: #409eff;
  border-bottom: solid 2px #409eff;
}
.contain_div {
  margin: 10px;
}
.cont_btns {
  float: right;
  margin: 0px 0px 20px 0;
}
.contain_header {
  background-color: #fff;
  padding: 10px;
}
.cont_btns li {
  display: inline-block;
}

.contain_body {
  background-color: #fff;
  margin-top: 20px;
  position: relative;
  padding-bottom: 35px;
}
.contain_body_head {
  display: block;
  padding: 10px 0 10px 10px;
  font-size: 16px;
  background-color: #f8f8f8;
}
.pageDiv {
  position: absolute;
  right: 0;
  bottom: 0;
}

.m-search {
  margin-bottom: -15px;
}
</style>



// WEBPACK FOOTER //
// src/components/good/ac20OrderList.vue